export function initHeaderSearch() {
    const searchBtns = document.querySelectorAll(".po-header-search__btn");
    const forms = document.querySelectorAll(".po-header-search__form");

    if (!searchBtns.length || !forms.length) return;

    searchBtns.forEach((btn, index) => {
      btn.addEventListener("click", () => {
        forms[index].classList.add('active')
        btn.classList.add('hidden')
      });
    })

    const resetBtns = document.querySelectorAll(".po-header-search__reset");
    if (!resetBtns.length) return;
    resetBtns.forEach((btn, index) => {
      btn.addEventListener("click", () => {
        forms[index].classList.remove('active')
        searchBtns[index].classList.remove('hidden')
      });
    })
  }